module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAsYAAAAICAMAAADNy8lqAAAAPFBMVEVHcEzFxcXExMTDw8PDw8PDw8PExMTU1NTDw8PDw8PDw8PExMTDw8PDw8PGxsbExMTDw8PDw8PDw8PDw8NwoXtUAAAAFHRSTlMALJDV8/+PBpb9lb++Ky2Ukb3Wias5rNgAAAB8SURBVHgB7ciFscUwDETRa1Qchv5r/Rgq4Wlm16A9AiDElEvJubzy+ZblnGrgP9a1v3VK5YoXy3LrDcCGc13rWWTZk0cDuhNtmtpZZdmTO5ivvsByVln25DaznnUzsO2ELHtyZP+bbTEAW1qRZW9OHCnnVCfOTFWWvfn4BnOldH8MHSusAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/f5_coupon_gray@2x.png
// module id = gtFA
// module chunks = 0